module.exports = __webpack_public_path__ + "94ba0044fc410f83e81784ac5f66a0af.png";